import React, { Component } from "react";
import Empty from "../../image/empty.svg"
import axios from "axios";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import { Link } from "react-router-dom";
import LoadingError from "../../part/loading_error";


class TutorStudents extends Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        students: [],
        isContactVisible: false,
        loading : false
    }
    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.fetchStudents();

        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                if (user && user.role === 'student') {
                    window.location.href = '/dashboard';
                }
            } catch (error) {
                console.error("Error parsing user data:", error);
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
            }
        } else {
            localStorage.removeItem('user');
            localStorage.removeItem('accessToken');
            window.location.href = '/login';
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
    };

    fetchStudents = async () => {
        this.setState({loading : true})
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/all-students/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ students: response.data, loading: false });
            console.log("API Response:", response.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/";
            } else {
                console.error("Error fetching data:", error);
            }
            this.setState({loading :false})
        }
    };


    render() {
        const { menuCoverWidth, students , loading} = this.state;

        const studentlist = students.length > 0 ? students.map((info, index) => {
            return (
                <tr key={info.id}>
                    <td className="sn">{index + 1}</td>
                    <td>{info.first_name}</td>
                    <td>{info.last_name}</td>
                    <td>{info.email}</td>
                    <td>{info.phone_number}</td>
                    <td>{info.address}</td>
                    <td>{info.source}</td>
                    <td className="delete" ><Link to={`/studentProfile/${info.id}/${info.first_name}`}><button className="delete-button" style={{ backgroundColor: "rgb(0,0,0,0)", color: "rgba(0, 0, 0, 0.8)", width: "150px", border: "1px solid rgb(20,107,217)", borderRadius: "30px"}} >View Course</button></Link></td>
                </tr>

            )
        }) : (
            <tr className="course_list_empty">
                <td>Loading ......</td>
            </tr>
        )

        return (
            <div className="dashboard">
                <DashSearchHeader onResize={this.handleResize} />
                <TutorDashMenu />
                <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 10px)`, overflow: 'hidden' }}>
                    <div className="course_head" style={{padding: "30px 0px"}} >
                        <h2> Student </h2>
                    </div>

                    <div className="course_body">
                        <div className="course_body_cover">

                            {students.length > 1 ?
                                < div className="table">
                                    <table className="librarytable">
                                        <thead>
                                            <tr>
                                                <th className="sn">S/N</th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Email</th>
                                                <th>Phone Number </th>
                                                <th className="course"> Address </th>
                                                <th>source</th>
                                                <th className="delete">View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {studentlist}
                                        </tbody>
                                    </table>
                                </div> :
                                <div className="course_list_empty">
                                    <img src={Empty} alt="not avaialable" /><br />
                                    <h5>No available course <br />with that specification.</h5>
                                    <button onClick={this.handleRefresh}>Reset Filter</button>
                                </div>
                            }
                        </div>
                    </div>

                    <FooterDashboard />
                    <Policy />
                </div>
                {loading ? <LoadingError /> : null}
            </div>
        )
    }
}

export default TutorStudents